import { defineStore } from "pinia";
import * as YachtService from "@/services/yacht.service";
import * as BlogService from "@/services/blog.service";
import {ref} from "vue";
import {useBlogStore} from "@/stores/blogStore";
import {useRouter} from "vue-router";


export const useArticleStore = defineStore('article', () => {

    const router = useRouter();
    const selectedArticleSlug = ref('')
    const selectedArticle = ref(null)
    const loading = ref(false)
    const error = ref<string | null>(null)
    const blogStore = useBlogStore();

    const fetchArticle = async (slug: string) => {
        selectedArticleSlug.value = slug
        loading.value = true
        error.value = null

        try {
            const response = await BlogService.getChildren("travel-inspiration")
            const page = response.data.find((y) => y.slug === slug)

            if (!page) throw new Error('Article not found')

            selectedArticle.value = page;
        } catch (err: any) {
            error.value = err?.message || 'Error fetching article'
        } finally {
            loading.value = false
        }

    }

    const visitArticle = async (slug: string) => {
        await fetchArticle(slug)
        router.push({ path: `/magazine/${slug}` })
    }

    function getPage(slug: string) {
        return BlogService.getPageContents(slug)
    }

    return {
        selectedArticleSlug,
        selectedArticle,
        loading,
        error,
        fetchArticle,
        visitArticle,
        getPage
    }

});

